<template>
  <div class="container">
    <content-header :data="[{text:'测试一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="关键词"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="test_name"
            label="测试名称"
            width="150"
            fixed
            >
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="开始时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="结束时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="test_paper_name"
            label="试卷名称">
          </el-table-column>
          <el-table-column
            label="试卷难度">
            <template slot-scope="scope">
              <span>{{scope.row.difficulty==1?'容易':(scope.row.difficulty==2?'适中':'较难')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="试卷介绍">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改测试' : '添加测试'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="test_paper_id" label="试卷" :label-width="formLabelWidth">
              <el-select v-model="curObj.test_paper_id" clearable value-key="id" placeholder="请选择试卷">
                <el-option
                  v-for="item in testPaperIds"
                  :key="item.test_paper_id"
                  :label="item.test_paper_name"
                  :value="item.test_paper_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="start_time" label="开始日期" :label-width="formLabelWidth">
              <el-date-picker
                v-model="curObj.start_time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="end_time" label="结束日期" :label-width="formLabelWidth">
              <el-date-picker
                v-model="curObj.end_time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import date from 'utils/date'
  import TestModel from 'models/test'
  import TestPaperModel from 'models/testPaper'

  export default {
    components: {
    },
    data () {
      return {
        keywords: '',
        tableData: [],
        isObjShow: false,
        testPaperIds: [],
        defaultObj: {
          id: '',
          name: '',
          test_paper_id: '',
          start_time: date(+(new Date())),
          end_time: ''
        },
        curObj: {},
        formLabelWidth: '120px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          test_paper_id: [{ required: true, message: '请选择试卷', trigger: 'blur' }],
          start_time: [{ required: true, message: '请选择开始日期', trigger: 'blur' }],
          end_time: [{ required: true, message: '请选择开始日期', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      //
      this.getObjList()
      TestPaperModel.find().then(res => {
        this.testPaperIds = res.item_list
      })
    },
    methods: {
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        console.log(_opts)
        //
        TestModel.find(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            TestModel.delete({
              id: item.row.test_id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = this.defaultObj
        this.isObjShow = true
      },
      newHandle () {
        TestModel.create(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.test_id,
          name: item.row.test_name,
          test_paper_id: item.row.test_paper_id,
          start_time: item.row.start_time,
          end_time: item.row.end_time
        }
        this.isObjShow = true
      },
      editHandle () {
        TestModel.update(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block

</style>



// WEBPACK FOOTER //
// src/views/Test.vue